import { AnnotationSize, AnnotationType, ChartConfig, ChartStyle, DownloadConfig, ExportFormat, Resolution } from './types';

export const DEFAULT_CHART_CFG: ChartConfig = {
    showAnnotations: true,
    style: ChartStyle.Line,
    showGridLines: true,
    annotationType: AnnotationType.GrowthPercent,
    matchSeriesColor: true,
    startFromZero: false,
    annotationSize: AnnotationSize.L,
};

export const DEFAULT_DOWNLOAD_CONFIG: DownloadConfig = {
    title: '',
    width: 1024,
    height: 732,
    backgroundColor: '#FFFFFF',
    showHeadings: true,
    resolution: Resolution.MEDIUM,
    exportAs: ExportFormat.PNG,
    fileName: 'chart',
};

export const COLORS: readonly string[] = [
    '#0c7d46',
    '#666666',
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
    '#e67300',
    '#8b0707',
    '#651067',
    '#329262',
    '#5574a6',
    '#3b3eac',
];

export const FONT_FAMILY_HEADING = 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif';
export const FONT_FAMILY_CHART = 'verdana, sans-serif';

export const ROTATE_LABEL_THRESHOLD = 13;

/** Pixel spacing between each stacked right-side Y-axis (offset increment and gridRight unit). */
export const RIGHT_AXIS_STEP = 60;
